import {
  VirtualCardFlowProvider,
  withVirtualCardFlow,
  useVirtualCardFlow,
} from './virtualCardsFlow';

export const virtualCardFlow = {
  VirtualCardFlowProvider,
  withVirtualCardFlow,
  useVirtualCardFlow,
};
